export const modulo = (a, b) => {
  return a > b ? a % b : b % a
}
